import React from 'react';
import { VictoryLabel, VictoryLine } from 'victory';
import { ChartDataPoint } from '../../axisUtils';
import { pad } from '../../../screens/LocationManagement/components/BuildingSettingsModal/data';

interface DashedLineProps {
  level: number,
  stroke: string,
  fill: string,
  title: string,
  data: ChartDataPoint[],
  chartHeight: number,
  width?: number,
  unit?: string,
  timeFormat?: boolean,
}

const DashedLine = ({
  level, stroke, fill, title, data, chartHeight, unit, timeFormat,
}: DashedLineProps) => {
  const value: string = timeFormat ? `${Math.floor(level)}:${pad(60 * (level % 1))}`
    : `${Math.round(level) ?? '-'}${unit ?? ''}`;
  const label: string = `${title}: ${value}`;
  const width: number = label.length * 6;
  return Number.isFinite(level) && <VictoryLine
    data={[
      { y: level, x: 0 },
      { y: level, x: Math.max(0, (data?.length ?? 1)), label },
    ]}
    labels={({ datum }) => datum.label}
    labelComponent={<VictoryLabel
      textAnchor='end'
      dx={-12}
      dy={-12 - chartHeight * 0.005}
      backgroundStyle={{ fill }}
      backgroundPadding={4} backgroundComponent={<svg
        {...{ width }}
        height={17}
      >
        <rect
          {...{ stroke, fill }}
          strokeWidth={1}
          rx={4}
          width='100%'
          height='100%'
        />
      </svg>}
      style={{
        fill: stroke,
        fontSize: 11,
        height: 17,
        fontFamily: 'Roboto_400Regular',
      }}
    />}
    style={{
      data: {
        stroke,
        strokeWidth: 1.5,
        opacity: 0.4,
        strokeDasharray: '1.5, 6',
      },
    }}
  />;
};

export default DashedLine;
